import { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { Link } from "react-router-dom";
import PageLayout from "./components/PageLayout";

function SavedBuilds() {
  const [savedBuilds, setSavedBuilds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setSavedBuilds([]);
        setLoading(false);
        return;
      }

      const q = query(
        collection(db, "favorites"),
        where("userId", "==", user.uid)
      );

      const snapshot = await getDocs(q);

      const list = [];

      snapshot.forEach((doc) => {
        list.push(doc.data());
      });

      setSavedBuilds(list);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <PageLayout title="Saved Builds" maxWidth="1100px">
      {loading && <p>Loading saved builds...</p>}

      {!loading && savedBuilds.length === 0 && (
        <p style={{ opacity: 0.7 }}>
          You have not saved any builds yet.
        </p>
      )}

      <div style={gridStyle}>
        {savedBuilds.map((build) => (
          <Link
            key={build.favoriteId}
            to={`/user/${build.ownerUsername}/car/${build.carId}`}
            style={cardLinkStyle}
          >
            <div style={cardStyle}>
              {build.imageUrl ? (
                <img
                  src={build.imageUrl}
                  alt={build.carName}
                  style={carImageStyle}
                />
              ) : (
                <div style={placeholderImageStyle}>No Photo</div>
              )}

              <div style={cardContentStyle}>
                <h2>{build.carName}</h2>

                <p style={{ opacity: 0.7 }}>
                  @{build.ownerUsername}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </PageLayout>
  );
}

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
  gap: "18px",
  marginTop: "24px",
};

const cardLinkStyle = {
  textDecoration: "none",
  color: "white",
};

const cardStyle = {
  backgroundColor: "#1c1c1c",
  borderRadius: "16px",
  overflow: "hidden",
};

const carImageStyle = {
  width: "100%",
  height: "180px",
  objectFit: "cover",
};

const placeholderImageStyle = {
  height: "180px",
  backgroundColor: "#333",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#aaa",
};

const cardContentStyle = {
  padding: "16px",
};

export default SavedBuilds;